import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { Identifiable, Project as P } from "@planzone/dto";

import { FolderIcon } from "@common/folderIcon";
import { Section } from "../section";
import { Loader } from "../loader";
import { filterSearch } from "../utils";
import { ScrollPane } from "../scrollPane";
import { Props } from "./types";
import { Project } from "./project";
import { useProjects } from "./utils";
import styles from "./styles.scss";

function Projects({ search, filter, setFilter, isOpen }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projects,
    retrieveProjects,
  } = useProjects();
  const selectProject = (project: Identifiable<P>) =>
    setFilter(filter ? [...filter, project] : [project]);
  const unSelectProject = ({ uuid }: Identifiable<P>) =>
    filter && setFilter(filter.filter((project) => project.uuid !== uuid));

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjects();
  }, []);

  return (
    <Section
      header={
        <div className={styles.header}>
          <FolderIcon className={styles.icon} />
          <p className={styles.title}>
            {t("common.filterMenu.projects.title")}
          </p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              [...filterSearch(projects, search)]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((project) => (
                  <Project
                    key={project.uuid}
                    project={project}
                    isSelected={
                      !!filter &&
                      !!filter.find(({ uuid }) => uuid === project.uuid)
                    }
                    select={() => selectProject(project)}
                    unSelect={() => unSelectProject(project)}
                  />
                ))
            ) : (
              <Loader />
            )}
          </div>
        </ScrollPane>
      }
      isOpen={isOpen}
    />
  );
}

export { Projects };
